/* eslint-disable */
import React from 'react'
import AwsConfig from '../../Config/AwsConfig'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import { KTColors } from '../Constants/KTColors'

const MultiBackgroundImages = props => {
  let { images } = props

  images = images.map(item => {
    if (item.imageValue) {
      return { image: item.imageValue, position: item.position }
    }

    const cdnurl = AwsConfig.cdn_url

    let srcimage = item.image
    if (srcimage && !srcimage.includes(cdnurl)) {
      srcimage = cdnurl + srcimage
    }

    return { image: srcimage, position: item.position }

    // return item.imageValue ? { image: item.imageValue } : { image: item.image }
  })
  const imagesLength = images?.length
  const renderImage = (image, index, height) => {
    const changeObjFitStyle = (imagesLength == 3 && index == 0) || imagesLength == 2
    const srcimage = image?.image
    console.log(srcimage, 'cdnurlcdnurl123')
    return (
      <div id='portrait' style={{ width: '10%' }}>
        <div
          key={`img_${index}`}
          className='prediv'
          style={{
            position: 'relative',
            left: '-10px',
            width: '24.7rem',
            backgroundImage: `url(${srcimage})`,
            backgroundSize: '100% 100%',
          }}
        >
          <img
            className='previewImgM'
            src={srcimage}
            alt='User Avatar'
            style={{
              height: heightPercentageToDP(height),
              /* width: '220%', */
              /*	objectFit: 'cover', */ ...image.position,
            }}
          ></img>
        </div>
      </div>
    )
  }

  const render3Images = () => {
    let imageHeight = 34.6
    if (props.type == 'ShortByte') {
      switch (props.shortByteTemplateType) {
        case 'Small':
          imageHeight = 65
          break
        case 'Medium':
          imageHeight = 55
          break
        case 'Large':
          imageHeight = 35
          break
        default:
          imageHeight = 65
          break
      }
    }

    return (
      <div
        className='row'
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          height: heightPercentageToDP(imageHeight),
          width: widthPercentageToDP('100'),
          marginLeft: -4,
        }}
      >
        <div
          className='col-md-6'
          style={{
            width: widthPercentageToDP('50'),
            height: heightPercentageToDP(imageHeight),
            borderColor: 'white',
            borderStyle: 'solid',
            borderWidth: 2,
          }}
        >
          {renderImage(images[0], 0, imageHeight)}
        </div>
        <div className='col-md-6'>
          <div
            style={{
              width: widthPercentageToDP('50'),
              height: heightPercentageToDP(imageHeight / 2),
              borderColor: 'white',
              borderStyle: 'solid',
              borderWidth: 2,
            }}
          >
            {renderImage(images[1], 1, imageHeight / 2)}
          </div>
          <div
            style={{
              width: widthPercentageToDP('50'),
              height: heightPercentageToDP(imageHeight / 2),
              borderColor: 'white',
              borderStyle: 'solid',
              borderWidth: 2,
            }}
          >
            {renderImage(images[2], 2, imageHeight / 2)}
          </div>
        </div>
      </div>
    )
  }

  const renderImages = () => {
    let imageHeight = 34.6
    let fourimageHeight = 17
    if (props.type == 'ShortByte') {
      switch (props.shortByteTemplateType) {
        case 'Small':
          imageHeight = 65
          fourimageHeight = 65 / 2
          break
        case 'Medium':
          imageHeight = 55
          fourimageHeight = 55 / 2
          break
        case 'Large':
          imageHeight = 35
          fourimageHeight = 35 / 2
          break
        default:
          imageHeight = 65
          fourimageHeight = 65 / 2
          break
      }
    }

    return (
      <div
        className={props.type == 'ShortByte' ? '' : 'row'}
        style={{
          flexWrap: imagesLength == 4 && props.type == 'ShortByte' ? 'wrap' : '',
          display: 'flex',
          flexDirection: 'row',
          height: heightPercentageToDP(imageHeight),
          width: widthPercentageToDP('100'),
          margin: -2,
        }}
      >
        {console.log(images, 'images===========================================')}
        {images.map((item, index) => {
          console.log(item.position, 'item===================')
          const imagesHeight = imagesLength >= 4 ? fourimageHeight : `${imageHeight}`
          return index <= 3 ? (
            <div
              className={imagesLength == 4 && props.type == 'ShortByte' ? 'col-md-6' : ''}
              style={{
                width: imagesLength != 1 ? '50%' : '100%',
                height: imagesLength >= 4 ? '50%' : '100%',
                borderStyle: 'solid',
                borderColor: 'white',
                borderWidth: 2,
                alignItems: 'center',
                justifyContent: 'center',
              }}
              key={`image_${index}`}
            >
              {item.image ? renderImage(item, index, imagesHeight) : null}
            </div>
          ) : null
        })}
      </div>
    )
  }

  return imagesLength == 3 ? render3Images() : renderImages()
}

export default MultiBackgroundImages
